(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-faq"] && !Shopify.designMode) return;
  try {
    
  const faqNavSelect = document.querySelector('.js-faq-nav-select');

  if (faqNavSelect) {
    faqNavSelect.addEventListener('change', () => {
      window.location.href = faqNavSelect.value;
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-faqs"] && !Shopify.designMode) return;
  try {
    
  const faqSelect = document.querySelector('.js-faq-nav-select');

  if (faqSelect) {
    faqSelect.addEventListener('change', () => {
      window.location.href = faqSelect.value;
    });
  }

  const faqHandleParam = new URLSearchParams(window.location.search).get('q');

  if (faqHandleParam) {
    const faqTarget = document.getElementById(`faq-${faqHandleParam}`);

    if (faqTarget) {
      faqTarget.open = true;
      faqTarget.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
